import { createEditor, Editor, Element, Node, Path, Transforms } from "slate"
import {
  Editable,
  ReactEditor,
  RenderElementProps,
  Slate,
  useEditor,
  useFocused,
  useSelected,
  withReact
} from "slate-react"

import { PhotoEntity } from "../models/PhotoModel"
import { uniqueKey } from "./uniqueKey"

export const insertImages = (editor: ReactEditor, images: PhotoEntity[]) => {
  const node = {
    type: "images",
    layout: "Justify",
    images, // : images.map(image => ({ ...image })),
    children: [{ text: "" }]
  }
  const at = editor.selection ?? [editor.children.length]
  Transforms.insertNodes(editor, node, { at })
  ReactEditor.focus(editor)
}

type MoveTarget = {
  node: Node
  path: Path
  matchIndex: number
}

export function moveImage(editor: Editor, to: string, from: string) {
  let targetFrom: MoveTarget | undefined
  let targetTo: MoveTarget | undefined

  // XXX: ネストしたNodeまで探索で効率が悪い
  for (const [node, path] of Node.nodes(editor)) {
    if (node.type === "images") {
      if (!targetFrom) {
        const matchIndexFrom = (node.images as any[]).findIndex(
          (image: { id: string }) => image.id === from
        )
        if (matchIndexFrom !== -1) {
          targetFrom = {
            node,
            path,
            matchIndex: matchIndexFrom
          }
        }
      }
      if (!targetTo) {
        const matchIndexTo = (node.images as any[]).findIndex(
          (image: { id: string }) => image.id === to
        )
        if (matchIndexTo !== -1) {
          targetTo = {
            node,
            path,
            matchIndex: matchIndexTo
          }
        }
      }
    }
    if (targetFrom && targetTo) {
      break
    }
  }
  if (targetFrom && targetTo) {
    if (targetFrom.path === targetTo.path) {
      // 同じグループ
      const images = [...targetFrom.node.images]
      ;[images[targetFrom.matchIndex], images[targetTo.matchIndex]] = [
        images[targetTo.matchIndex],
        images[targetFrom.matchIndex]
      ]
      const newNode = { ...targetFrom.node, images }
      Transforms.setNodes(editor, newNode, { at: targetFrom.path })
      // Transforms.move(editor)
    } else {
      const fromImages = [...targetFrom.node.images]
      const insertImageData = fromImages[targetFrom.matchIndex]
      fromImages.splice(targetFrom.matchIndex, 1)
      const fromNewNode = { ...targetFrom.node, images: fromImages }
      if (fromImages.length === 0) {
        Transforms.removeNodes(editor, { at: targetFrom.path })
      } else {
        Transforms.setNodes(editor, fromNewNode, { at: targetFrom.path })
      }
      const toImages = [...targetTo.node.images]
      toImages.splice(targetTo.matchIndex, 0, insertImageData)
      const toNewNode = { ...targetTo.node, images: toImages }
      Transforms.setNodes(editor, toNewNode, { at: targetTo.path })
    }
  }
}

export const withImages = (editor: Editor & ReactEditor) => {
  const { insertData, isVoid, normalizeNode } = editor

  editor.isVoid = element => {
    return element.type === "images" ? true : isVoid(element)
  }

  editor.normalizeNode = element => {
    const [node, path] = element
    normalizeNode(element)
  }

  editor.insertData = data => {
    /*
    const text = data.getData("text/uri-list")
    if (isImageUrl(text)) {
      insertImage(editor, text)
    } else {
    }
    */
    insertData(data)

    // 良い実装でないが、コピーすると PhotoEntity.id がかぶるため、uuid を付け足す
    // XXX: ネストしたNodeまで探索で効率が悪い
    for (const [node, path] of Node.nodes(editor)) {
      if (node.type === "images") {
        const images = node.images.map((image: any) => ({
          ...image,
          id: uniqueKey()
        }))
        const newNode = { ...node, images }
        Transforms.setNodes(editor, newNode, { at: path })
      }
    }
  }

  return editor
}
